import classNames from 'classnames'
import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'

import * as styles from './BlogPost.module.scss'
import ROUTES from '../../constants/routes'
import { RegionContext } from '../../context/region-context'
import ContentWithStickyColumn from '../content-with-sticky-column/ContentWithStickyColumn'
import NameWithPubdate from '../name-with-pubdate/NameWithPubdate'
import LinkWithIcon from '../ui/buttons/link-with-icon/LinkWithIcon'

function BlogPost({
  title,
  content,
  postImage,
  pubDate,
  authorName,
  thumbnail,
}) {
  const region = useContext(RegionContext)

  const sticky = (
    <>
      <LinkWithIcon
        className={styles.link}
        to={region.isUSRegion ? ROUTES.US_BLOG : ROUTES.BLOG}
        isReversed
      >
        Back to Blog
      </LinkWithIcon>
      <header>
        <h1 className={classNames(styles.title, styles.titleMobile)}>
          {title}
        </h1>
        {postImage && (
          <div className={styles.imgWrapper}>
            <GatsbyImage
              image={postImage}
              alt="Bamboo post"
              className={styles.img}
              width={540}
            />
          </div>
        )}

        <NameWithPubdate {...{ pubDate, authorName, thumbnail }} />
      </header>
    </>
  )
  return (
    <ContentWithStickyColumn info={sticky}>
      <h1 className={classNames(styles.title, styles.titleDesktop)}>{title}</h1>
      <section
        className={styles.content}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </ContentWithStickyColumn>
  )
}

BlogPost.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  postImage: PropTypes.object.isRequired,
  pubDate: PropTypes.string.isRequired,
  authorName: PropTypes.string.isRequired,
  thumbnail: PropTypes.object.isRequired,
}

export default BlogPost
